import BigButton from "components/atoms/buttons/BigButton";
import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import React from "react";
import styled from "styled-components";
import { ButtonWrapper } from "styles/ModalCommonStyled";

export default function TermsModal({
  title,
  content,
  onModal,
  onAgree,
}: {
  title: string;
  content: React.ReactNode;
  onModal: () => void;
  onAgree: () => void;
}) {
  return (
    <BigPopupTemplate title={title} onModal={onModal}>
      <AgreementContent>{content}</AgreementContent>
      <ButtonWrapper>
        <BigButton
          label="Agree"
          onClickBtn={onAgree}
          data-testid="terms-text-text-button-agree"
        />
      </ButtonWrapper>
    </BigPopupTemplate>
  );
}

const AgreementContent = styled.div`
  max-height: 70vh;
  overflow-y: auto;
`;
